// CRITICAL: This import MUST be first - it registers all Chart.js components globally
import './config/chartConfig';

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from './msalconfig';

const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL and handle redirect response
msalInstance.initialize().then(() => {
  // Handle redirect response if returning from Microsoft login
  msalInstance.handleRedirectPromise()
    .then((response) => {
      if (response) {
        console.log("✅ Redirect response received:", response.account?.username);
      }
    })
    .catch((error) => {
      console.error("Redirect error:", error);
    });
});

// Suppress ResizeObserver errors globally
const debounce = (callback, delay) => {
  let tid;
  return function (...args) {
    const ctx = this;
    clearTimeout(tid);
    tid = setTimeout(() => callback.apply(ctx, args), delay);
  };
};

// Handle ResizeObserver errors
window.addEventListener('error', e => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
      e.message === 'ResizeObserver loop limit exceeded') {
    e.stopPropagation();
    e.preventDefault();
  }
});

// Patch ResizeObserver to debounce callbacks
if (window.ResizeObserver) {
  const RO = window.ResizeObserver;
  window.ResizeObserver = function(...args) {
    const callback = args[0];
    args[0] = debounce(callback, 20);
    return new RO(...args);
  };
  window.ResizeObserver.prototype = RO.prototype;
}

// Also suppress console errors as backup
const originalError = console.error;
console.error = (...args) => {
  if (args[0]?.includes?.('ResizeObserver loop')) {
    return;
  }
  originalError.apply(console, args);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </MsalProvider>
  </React.StrictMode>
);

reportWebVitals();